import { render, staticRenderFns } from "./allModule.vue?vue&type=template&id=ed3f2376&scoped=true&"
import script from "./allModule.vue?vue&type=script&lang=js&"
export * from "./allModule.vue?vue&type=script&lang=js&"
import style0 from "./allModule.vue?vue&type=style&index=0&id=ed3f2376&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3f2376",
  null
  
)

export default component.exports